import React, { useState, useEffect } from "react";
import CgFormCreator from "../../../common/CgFormCreator";
import PopupModal from "../../../common/PopupModal";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTechnologyList,
  fetchTechnologyCheckList,
  updatedTechnologyList,
  deleteTechnologyList,
} from "../../../store/PracticeInfo/TechnologyActions";
import { useLocation } from "react-router-dom";
import "./technology.scss";

const Technology = ({
  practiceId,
  onlyPopup = false,
  openTechPopup,
  closePopupCallback = () => {},
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [technologyValues, setTechnolgyValues] = useState();
  const [showError, setShowError] = useState(false);

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const [pracId, setPracId] = useState(practiceId ? practiceId : locationHeaderData[2]);

  const dispatch = useDispatch();
  const { technologyData, isTechnologyLoading, technologyErrorMsg } = useSelector(
    (state) => state.practiceTechnologyList
  );
  const { technologyCheckData, technologyCheckErrorMsg } = useSelector(
    (state) => state.practiceTechnologyCheckList
  );

  useEffect(() => {
      if (practiceId) {
        setPracId(practiceId);
      } else {
        setPracId(locationHeaderData[2]); 
      }
    }, [practiceId]);

  useEffect(() => {
    setOpenPopup(openTechPopup);
  }, [openTechPopup]);

  useEffect(() => {
    setTechnolgyValues(technologyData);
  }, [technologyData]);
  useEffect(() => {
    dispatch(fetchTechnologyCheckList());
    dispatch(fetchTechnologyList(pracId));
  }, []);

  useEffect(() => {
    if (technologyErrorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [technologyErrorMsg]); 

  useEffect(() => {
    if (technologyCheckErrorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [technologyCheckErrorMsg]);

  const getCheckBoxDefault = (val) => {
    const defaultVal = [];
    technologyCheckData?.map((item1) => {
      const item2 = val?.find((item) => item.name === item1.name);
      if (item2) {
        defaultVal.push(item1.code);
      }
    });
    return defaultVal;
  };

  const technologySchema = [
    {
      component: "checkbox",
      shouldRenderCheckboxWithBackgroundImageStyle:true,
      options: technologyCheckData,
      keyValues: { label: "name", value: "code" },
      onSelect: () => {},
      defaultValues: getCheckBoxDefault(technologyValues),
      name: "TechnologyCheckbox",
      customRenderLabel: () => {
        return (
          <div className="popup-checkbox-subheading">
            <p>Check all that applies</p>
          </div>
        );
      },
    },
  ];

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = async (displayId) => {
    const getData = await dispatch(deleteTechnologyList({practiceId:pracId, deleteDisplayID:displayId}));
    if(getData?.payload?.success === false){
      setShowError(true);
            setTimeout(() => {
              setShowError(false);
            }, 2000);
    }

    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: false,
    }));
    
    dispatch(fetchTechnologyList(pracId));
  };

  const formSelectCheckbox = (val) => {
    let newArray = [];
    technologyCheckData.map((item) => {
      const item2 = val?.find((item1) => item1 === item.code);
      if (item2) {
        newArray.push(item.code);
      }
    });
    return newArray;
  };

  const RenderFormCreatorForTechnology = () => {
    if (isTechnologyLoading) return null;
    return (
      <div className="technology-CG-Form">
        <CgFormCreator
          formClassName="technology-form"
          primaryButton="Save"
          onSubmitCallback={(val) => {
            const convertedData = formSelectCheckbox(val["TechnologyCheckbox"]);
            dispatch(updatedTechnologyList({practiceId:pracId, data:{"technologies":convertedData}}));
            setOpenPopup(!openPopup);
            closePopupCallback(convertedData);
          }}
          schema={technologySchema}
          onCancel={() => {
            closePopupCallback();
            setOpenPopup(false);
          }}
        />
      </div>
    );
  };
  const RenderTechnologyPopupModal = () => {
    return (
      <div>
        <PopupModal
          customRender={!technologyCheckErrorMsg ? RenderFormCreatorForTechnology : RenderTechnologyCheckError}
          isOpen={openPopup}
          onSave={() => {
            setOpenPopup(!openPopup);
            closePopupCallback();
          }}
          onClose={() => {
            setOpenPopup(!openPopup);
            setTechnolgyValues(technologyValues);
            closePopupCallback();
          }}
          popupHeading={"Technology"}
          width="83%"
        />
      </div>
    );
  };

  const RenderTechnologySection = () => {
    if (isTechnologyLoading) return null;
    return (
      <div>
        {technologyValues?.map((item) => {
          return (
            <>
              <div className="gencert-list">
                {item.name}
                <div className="deleteBtnwithConfirm">
                  {confirmDeleteMap[item.displayId] && (
                    <button
                      type="button"
                      className="btn border-0 canceldelete"
                      onClick={() => toggleConfirmDelete(item.displayId, false)}
                    >
                      CANCEL
                    </button>
                  )}
                  <button
                    type="button"
                    className={`btn ${
                      confirmDeleteMap[item.displayId]
                        ? "deleteConfirmation"
                        : "border-0"
                    }`}
                    onClick={() => {
                      if (confirmDeleteMap[item.displayId]) {
                        deleteAPiCall(item.displayId);
                      } else {
                        toggleConfirmDelete(item.displayId, true);
                      }
                    }}
                  >
                    {confirmDeleteMap[item.displayId] ? "CONFIRM" : "DELETE"}
                  </button>
                </div>
              </div>
            </>
          );
        })}
      </div>
    );
  };

  const RenderTechnologyError = () =>{
    if (!showError) return null;
    return(
      <div className="overlay-alert alert alert-danger" role="alert">
      {technologyErrorMsg}
      </div>
  )
  }

  const RenderTechnologyCheckError = () =>{
    return(
      <div className="overlay-alert alert alert-danger" role="alert">
      {technologyCheckErrorMsg}
      </div>
  )
  }

  const RenderNoTechnologyInfo = () => {
    if (technologyData.length > 0) return null;

    return (
      <div className="noDataInformationWrapper">
        No technology data for this practice
      </div>
    );
  };
  return (
    <div>
      {!onlyPopup && (
        <h3 className="section-header top-thirty overview">
          Technology
          <a
            className="btn edit-button"
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
          >
            +Add
          </a>
        </h3>
      )}
      {RenderTechnologyError()}
      {!onlyPopup && RenderTechnologySection()}
      {!onlyPopup && RenderNoTechnologyInfo()}
      {openPopup && RenderTechnologyPopupModal()}
    </div>
  );
};
export default Technology;
